import React from 'react';
import useAuth from '../../Utils/Hooks/useAuth';

interface AuthProps {
    code: string;
    action?: 'remove' | 'disable'; // 不符合权限时的处理, 移除或禁用
    children: React.ReactNode;
}

export function Auth({code, action = 'remove', children}: AuthProps) {
    const auth = useAuth();

    if (!auth(code) && action === 'remove') return null;

    if (!auth(code) && action === 'disable') {
        const child = React.Children.only(children);
        if (typeof child !== 'object') return null;
        if (!child) return null;
        if (!('type' in child)) return null;
        return React.cloneElement(child, {disabled: true});
    }

    return <>{children}</>;
}
